const i = (o) => {
  const n = new Date(o), s = /* @__PURE__ */ new Date(), e = n.getTime() - s.getTime(), t = e > 0;
  if (t) {
    const c = Math.floor(e / 36e5), r = Math.floor(e % (1e3 * 60 * 60) / (1e3 * 60)), a = Math.floor(e % (1e3 * 60) / 1e3);
    return {
      hours: c,
      minutes: r,
      seconds: a,
      isAhead: t
    };
  }
  return {
    hours: 0,
    minutes: 0,
    seconds: 0,
    isAhead: t
  };
};
export {
  i as getTimeDifference
};
//# sourceMappingURL=countDownUtil.js.map
